import type { SxProps, Theme } from '@captivateiq/quotient';

export const TEXT_COLUMN_MAX_WIDTH_PX = 640;

const EXPANDED_SX: SxProps<Theme> = {
  maxWidth: `${TEXT_COLUMN_MAX_WIDTH_PX}px`,
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  alignSelf: 'center',
};

const COLLAPSED_SX: SxProps<Theme> = {};

export const expandedTextColumnSx = (isExpanded: boolean): SxProps<Theme> => (isExpanded ? EXPANDED_SX : COLLAPSED_SX);
